
// There is only a production API; the stage client talks to it too.
// Locally, the dev server proxies /api to the API and the service worker adds the auth header.
// Uses self rather than window so the service worker can import it too.
export const API_ORIGIN = self.location?.hostname === 'localhost' ?
  `${self.location.origin}/api` :
  'https://api.charmed.cloud';
